export default __webpack_public_path__ + "static/media/Premco Global Limited.0a02bfb6.jpg";